import { FC } from "react";

import { IPickerListItem, Picker } from "@livechat/design-system-react-components";

import { Filter } from "constants/filters";
import { ActionType } from "interfaces/entities/audit-log";
import { capitalizeFirstLetter } from "utils/string";

import { IFilterConfig, IFilterUpdate } from "../interfaces";
import { withFilterBase } from "../withFilterBase";

type IProps = {
  filterValues: string[] | string;
  filterConfig: IFilterConfig;
  onChange(filterUpdate: IFilterUpdate<string | null>): void;
};

const items: IPickerListItem[] = [ActionType.Create, ActionType.Update, ActionType.Delete].map(action => ({
  key: action,
  name: capitalizeFirstLetter(action),
}));

const ActionFilter: FC<IProps> = ({ filterValues, onChange }) => {
  const handleChange = (selectedItem: IPickerListItem[] | null): void => {
    onChange({
      name: Filter.Action,
      value: selectedItem !== null ? selectedItem[0].key : null,
    });
  };

  const selected = items.filter(item =>
    Array.isArray(filterValues) ? filterValues.includes(item.key) : item.key === filterValues
  );

  return (
    <Picker
      id="action-filter"
      options={items}
      onSelect={handleChange}
      openedOnInit
      selected={selected}
      hideClearButton
    />
  );
};

export default withFilterBase(ActionFilter);
